import { useState, useEffect } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Grid,
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

import { useForm, useFieldArray } from "@pankod/refine-react-hook-form";
import axios from "utils/axios";
import { toast } from "react-toastify";

const fields = [
  {
    label: "Quantità",
    name: "quantity",
    required: true,
    type: "number",
    md: 6,
  },
  {
    label: "Grandezza Confezione",
    name: "unit_size",
    required: true,
    type: "number",
    md: 3,
  },
  {
    label: "Unità di misura",
    name: "unit_type",
    required: true,
    type: "select",
    options: [
      {
        label: "Kili",
        value: "kg",
      },
      {
        label: "Unità",
        value: "unità",
      },
      {
        label: "Litri",
        value: "lt",
      },
    ],
    md: 3,
  },
];

const PackagingEditor = ({ packaging, refreshPackagings }) => {
  const [open, setOpen] = useState(false);
  const [accordionOpen, setAccordionOpen] = useState(false);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      quantity: packaging?.quantity,
      unit_type: packaging?.unit_type,
      unit_size: packaging?.unit_size,
      lowest_price: packaging?.lowest_price,
      prices: packaging?.prices?.map((price) => {
        return {
          price: price.price,
          quantity_from: price.quantity_from,
          quantity_to: price.quantity_to,
        };
      }),
    },
  });

  const {
    fields: price_fields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "prices",
  });

  useEffect(() => {
    setValue("quantity", packaging?.quantity);
    setValue("unit_type", packaging?.unit_type);
    setValue("unit_size", packaging?.unit_size);
    setValue("lowest_price", packaging?.lowest_price);
    setValue(
      "prices",
      packaging?.prices?.map((price) => {
        return {
          price: price.price,
          quantity_from: price.quantity_from,
          quantity_to: price.quantity_to,
        };
      })
    );
  }, [packaging]);

  const submitHandler = (values) => {
    if (!values.prices || values.prices.length == 0) {
      toast.error("Inserire almeno un prezzo");
      return;
    }
    let fieldValue = [];
    values.prices.forEach((val) => {
      fieldValue.push({
        price: val.price,
        quantity_from: val.quantity_from,
        quantity_to: val.quantity_to,
      });
    });

    // console.log({
    //   quantity: values.quantity,
    //   unit_type: values.unit_type,
    //   unit_size: values.unit_size,
    //   lowest_price: values.lowest_price,
    //   prices: fieldValue,
    // });

    axios
      .put(`/api/packagings/${packaging.id}`, {
        data: {
          quantity: values.quantity,
          unit_type: values.unit_type,
          unit_size: values.unit_size,
          lowest_price: values.lowest_price,
          prices: fieldValue,
        },
      })
      .then((res) => {
        refreshPackagings();
        toast.success("Confezionamento aggiornato");
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Si è verificato un errore");
      });
  };

  return (
    <Grid item xs={12}>
      <Grid
        item
        xs={12}
        container
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Grid item xs={1} container>
          <IconButton
            onClick={() => {
              if (
                window.confirm(
                  "Sei sicuro di voler eliminare questo confezionamento?"
                )
              ) {
                setAccordionOpen(false);
                axios
                  .delete(`/api/packagings/${packaging.id}`)
                  .then((res) => {
                    refreshPackagings();
                    toast.success("Confezionamento eliminato");
                  })
                  .catch((err) => {
                    console.log(err);
                    toast.error("Si è verificato un errore");
                  });
              }
            }}
          >
            <DeleteForeverIcon fontSize="large" color="error" />
          </IconButton>
        </Grid>

        <Grid item xs={8}>
          <Accordion
            expanded={accordionOpen}
            onChange={() => setAccordionOpen(!accordionOpen)}
          >
            <AccordionSummary>
              <Typography variant="body1" ml={2}>
                {packaging?.quantity} confezioni da {packaging?.unit_size}{" "}
                {packaging?.unit_type}. Prezzo per famiglie meno abbienti: €
                {packaging?.lowest_price}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Prezzo (€)</TableCell>
                      <TableCell>Quantità da</TableCell>
                      <TableCell>Quantità a</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {packaging?.prices?.map((price) => {
                      return (
                        <TableRow key={price.id}>
                          <TableCell>{price.price}</TableCell>
                          <TableCell>{price.quantity_from}</TableCell>
                          <TableCell>{price.quantity_to}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid item xs={2}>
          <IconButton
            onClick={() => {
              setAccordionOpen(!accordionOpen);
            }}
          >
            {accordionOpen ? <ArrowUpward /> : <ArrowDownward />}
          </IconButton>

          <Button onClick={() => setOpen(true)}>Modifica</Button>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle>Confezionamento, Quantità e Prezzi</DialogTitle>
        <DialogContent>
          <Grid
            container
            direction="column"
            justifyContent="center"
            p={2}
            gap={2}
            alignItems="start"
          >
            <Grid container spacing={2}>
              {fields.map((field, index) => {
                return (
                  <AutoGeneratedInputCmp
                    key={index}
                    {...field}
                    register={register}
                    control={control}
                    errors={errors}
                    getValues={getValues}
                    setValue={setValue}
                  />
                );
              })}
            </Grid>

            <Divider sx={{ my: 2, width: "100%" }} />

            <Grid gap={1}>
              {price_fields?.map((price, index) => {
                const { id } = price;

                return (
                  <Box key={id} sx={{ display: "inline-flex" }} gap={2} mb={2}>
                    <TextField
                      type="number"
                      inputProps={{ min: 0 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            &euro;
                          </InputAdornment>
                        ),
                      }}
                      label="Prezzo"
                      color="primary"
                      {...register(`prices.${index}.price`, { required: true })}
                    />

                    <TextField
                      type="number"
                      inputProps={{ min: 0 }}
                      label="Quantità da"
                      color="primary"
                      {...register(`prices.${index}.quantity_from`, {
                        required: true,
                      })}
                    />

                    <TextField
                      type="number"
                      inputProps={{ min: 0 }}
                      label="Quantità a"
                      color="primary"
                      {...register(`prices.${index}.quantity_to`, {
                        required: true,
                      })}
                    />

                    <DeleteForeverIcon
                      onClick={() => remove(index)}
                      fontSize="large"
                      color="action"
                      style={{ marginTop: "8px" }}
                    />
                  </Box>
                );
              })}
            </Grid>
            <Button
              startIcon={<AddCircleIcon />}
              variant="outlined"
              color="primary"
              onClick={() => {
                append({ price: 0, quantity_from: 0, quantity_to: 0 });
              }}
            >
              Aggiungi Prezzo
            </Button>

            <Divider sx={{ my: 2, width: "100%" }} />

            <Grid container justifyContent="flex-end">
              <Grid item xs={3}>
                <TextField
                  {...register("lowest_price", {
                    required: true,
                  })}
                  fullWidth
                  type="number"
                  label="Prezzo per famiglie meno abbienti"
                  color="primary"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">&euro;</InputAdornment>
                    ),
                  }}
                  inputProps={{
                    min: 0,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 3, pr: 3 }}>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            color="error"
            variant="contained"
          >
            Annulla
          </Button>
          <Button
            onClick={handleSubmit(submitHandler)}
            color="success"
            variant="contained"
          >
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default PackagingEditor;
